import { errorMessage } from '../../constants/errorMessage'

// Stripe.js errors -> message for the customer. Stripe's own card/validation
// messages are safe to show; anything else gets the generic text.
export const getStripeErrorMessage = (error) => {
    if (!error) return errorMessage?.somethingWentWrong
    if (error.type === 'card_error' || error.type === 'validation_error') {
        return error.message || errorMessage?.somethingWentWrong
    }
    if (error.code === 'payment_intent_authentication_failure' || error.code === 'setup_intent_authentication_failure') {
        return 'Card authentication failed or was cancelled. Please try again or use another card.'
    }
    if (error.type === 'api_connection_error') {
        return 'Network error. Please check your connection and try again.'
    }
    return error.message || errorMessage?.somethingWentWrong
}
